import { useSettings } from 'core/hooks/useSettings'
import Drawer from 'core/components/drawer/Drawer'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import TransactionDetail, {
  TransactionDetailRef
} from 'core/widgets/transaction-detail/TransactionDetail'
import UnsavedModal from 'core/components/dialogs/UnsavedModal'
import useUrlSearch from 'core/hooks/useUrlSearch'
import useNavigation from 'core/hooks/useNavigation'
import { TransactionsUrl } from 'constants/RouteUrls'

const TransactionDetailDrawer = () => {
  const { get, set } = useSettings()
  const {
    tokenId,
    view,
    props: { readOnly, onSuccess } = {
      readOnly: false,
      onSuccess: () => {
        return
      }
    }
  } = get('transactionDetail') ?? {}

  const transactionDetailRef = useRef<TransactionDetailRef>(null)
  const [showUnsavedModal, setShowUnsavedModal] = useState(false)

  const [urlParams, setUrlParams] = useUrlSearch()
  const { pathname } = useNavigation()

  useEffect(() => {
    if (pathname !== TransactionsUrl) return

    const selectedParam = urlParams.get('t_sr')

    if (tokenId && !selectedParam && selectedParam !== tokenId) {
      urlParams.set('t_sr', tokenId)
      setUrlParams(urlParams)
      return
    }

    if (!tokenId && selectedParam) {
      urlParams.delete('t_sr')
      setUrlParams(urlParams)
    }
  }, [pathname, setUrlParams, tokenId, urlParams])

  const handleClose = useCallback(() => {
    set('transactionDetail', {
      view: 'personal',
      tokenId: '',
      props: {}
    })
  }, [set])

  const handleBeforeClose = useCallback(() => {
    if (!transactionDetailRef?.current?.getFormDirty()) {
      return handleClose()
    }

    setShowUnsavedModal(true)
  }, [handleClose])

  return (
    <Drawer
      show={!!tokenId}
      startFrom="right"
      onClose={handleBeforeClose}
      width="w-full md:w-2/4 lg:w-5/12"
      canExpand={false}
      contentClassNames="overflow-scroll h-screen"
    >
      <TransactionDetail
        ref={transactionDetailRef}
        view={view}
        transactionId={tokenId}
        onError={handleClose}
        onSuccess={() => {
          handleClose()
          onSuccess?.()
        }}
        readOnly={readOnly}
      />
      <UnsavedModal
        active={showUnsavedModal}
        overrideShow={showUnsavedModal}
        saveButtonText="Keep editing"
        onExit={() => {
          setShowUnsavedModal(false)
          setTimeout(() => {
            handleClose()
          }, 500)
        }}
        onSave={() => {
          setShowUnsavedModal(false)
        }}
      />
    </Drawer>
  )
}

export default TransactionDetailDrawer
